import { useState } from "react";
import axiosInstance from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { ParseErrors } from "../../utils/ParseErrors";
import ConfirmDialog from "../confirm-dialog";

interface TDeleteAgentModel {
  ToggleDeleteModel: () => void;
  id: number;
}

const DeleteAgentModel = ({ ToggleDeleteModel, id }: TDeleteAgentModel) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const deleteUser = async () => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.delete(`/user/delete/${id}`);
      toast.success(res.data.message);
      setIsLoading(false);
      ToggleDeleteModel();
    } catch (error) {
      console.log(error);
      toast.error(ParseErrors(error));
      setIsLoading(false);
    }
  };

  return (
    <ConfirmDialog
      title="Delete this agent?"
      description="The agent's account will be removed and they will lose access. This cannot be undone."
      confirmLabel="Delete"
      tone="destructive"
      loading={isLoading}
      onCancel={ToggleDeleteModel}
      onConfirm={deleteUser}
    />
  );
};

export default DeleteAgentModel;
